import { Progress, XCircle } from '@leanpay/ui'

interface LayoutHeaderProps {
    className?: string
    progress: number
    onLogout?: () => void
    isAuthenticated?: boolean
    children: any
}

export const LayoutHeader = ({
    progress,
    onLogout,
    isAuthenticated = false,
    children,
}: LayoutHeaderProps) => {
    return (
        <>
            <div className="flex flex-col bg-[linear-gradient(0deg,rgba(2,0,36,0)_0%,rgba(243,246,248,1)_58%)] max-w-[840px] w-full fixed items-center px-2 pt-1 z-10 rounded-md">
                <Progress className="h-1 rounded-md" value={progress} />
                <div
                    onClick={onLogout}
                    className={`pt-1 cursor-pointer self-end ${isAuthenticated ? 'block' : 'hidden'}`}
                >
                    <XCircle className="w-6 h-6 text-lp-dark1" />
                </div>
            </div>

            {children}
        </>
    )
}
